import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const SugeridoPage = () => {
  // Regiones
  const [regiones, setRegiones] = useState([]);
  const [loadingRegiones, setLoadingRegiones] = useState(true);
  const [errorRegiones, setErrorRegiones] = useState(null);

  // Marcas vehículo
  const [marcas, setMarcas] = useState([]);
  const [loadingMarcas, setLoadingMarcas] = useState(true);
  const [errorMarcas, setErrorMarcas] = useState(null);

  // Grupos de marcas
  const [grupos, setGrupos] = useState([]);
  const [loadingGrupos, setLoadingGrupos] = useState(true);

  // Líneas
  const [lineas, setLineas] = useState([]);
  const [loadingLineas, setLoadingLineas] = useState(true);
  const [errorLineas, setErrorLineas] = useState(null);

  // Marcas de producto (por líneas seleccionadas)
  const [marcasProducto, setMarcasProducto] = useState([]);
  const [loadingMarcasProducto, setLoadingMarcasProducto] = useState(false);
  const [errorMarcasProducto, setErrorMarcasProducto] = useState(null);

  // Estados generales
  const [region, setRegion] = useState('');
  const [suggestedItems, setSuggestedItems] = useState(50);
  const [discount, setDiscount] = useState('');
  const [onlyMainApp, setOnlyMainApp] = useState(false);

  // Selecciones
  const [selectedMarcaIds, setSelectedMarcaIds] = useState([]);
  const [selectedLineaIds, setSelectedLineaIds] = useState([]);
  const [selectedMarcaProductoIds, setSelectedMarcaProductoIds] = useState([]);

  const availableMarcaRef = useRef(null);
  const selectedMarcaRef = useRef(null);
  const availableLineaRef = useRef(null);
  const selectedLineaRef = useRef(null);
  const availableMarcaProductoRef = useRef(null);
  const selectedMarcaProductoRef = useRef(null);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState('');

  // Cargar regiones
  useEffect(() => {
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-regiones')
      .then(r => setRegiones(r.data || []))
      .catch(() => setErrorRegiones('Error al cargar regiones'))
      .finally(() => setLoadingRegiones(false));
  }, []);

  // Cargar marcas vehículo (sin filtro chinos)
  useEffect(() => {
    setLoadingMarcas(true);
    setErrorMarcas(null);
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-marcas-gabtec?soloChinos=false')
      .then(r => setMarcas(r.data || []))
      .catch(() => setErrorMarcas('Error al cargar marcas'))
      .finally(() => setLoadingMarcas(false));
  }, []);

  // Cargar grupos de marcas
  useEffect(() => {
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-grupos-marcas')
      .then(r => setGrupos(r.data || []))
      .catch(e => console.error('Error grupos:', e))
      .finally(() => setLoadingGrupos(false));
  }, []);

  // Cargar líneas
  useEffect(() => {
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-lineas-gabtec')
      .then(r => setLineas(r.data || []))
      .catch(() => setErrorLineas('Error al cargar líneas'))
      .finally(() => setLoadingLineas(false));
  }, []);

  // Recargar marcas de producto cuando cambian las líneas seleccionadas
  useEffect(() => {
    if (selectedLineaIds.length === 0) {
      setMarcasProducto([]);
      setSelectedMarcaProductoIds([]);
      return;
    }
    setLoadingMarcasProducto(true);
    setErrorMarcasProducto(null);
    axios.get('https://apigabtecbi.automarco.cl:3003/api/select-marcas-por-lineas', {
      params: { cla_ids: selectedLineaIds.join(',') }
    })
      .then(r => {
        setMarcasProducto(r.data || []);
        // Limpiar selecciones que ya no existen
        const ids = (r.data || []).map(m => String(m.marca_id));
        setSelectedMarcaProductoIds(prev => prev.filter(id => ids.includes(id)));
      })
      .catch(() => setErrorMarcasProducto('Error al cargar marcas de producto'))
      .finally(() => setLoadingMarcasProducto(false));
  }, [selectedLineaIds]);

  // ── Derived lists ───────────────────────────────────────────
  const availableMarcas = marcas.filter(m => !selectedMarcaIds.includes(String(m.value)));
  const selectedMarcas  = marcas.filter(m =>  selectedMarcaIds.includes(String(m.value)));

  const availableLineas = lineas.filter(l => !selectedLineaIds.includes(String(l.value)));
  const selectedLineas  = lineas.filter(l =>  selectedLineaIds.includes(String(l.value)));

  const availableMarcasProducto = marcasProducto.filter(m => !selectedMarcaProductoIds.includes(String(m.marca_id)));
  const selectedMarcasProducto  = marcasProducto.filter(m =>  selectedMarcaProductoIds.includes(String(m.marca_id)));

  // ── Mover marcas vehículo ───────────────────────────────────
  const moveMarcasRight = () => {
    if (!availableMarcaRef.current) return;
    const selected = Array.from(availableMarcaRef.current.selectedOptions).map(o => o.value);
    if (!selected.length) return;
    setSelectedMarcaIds(prev => [...new Set([...prev, ...selected])]);
  };
  const moveMarcasLeft = () => {
    if (!selectedMarcaRef.current) return;
    const selected = Array.from(selectedMarcaRef.current.selectedOptions).map(o => o.value);
    if (!selected.length) return;
    setSelectedMarcaIds(prev => prev.filter(id => !selected.includes(id)));
  };

  // Resaltar en el select izquierdo las marcas disponibles del grupo via backend
  const handleGrupoClick = (grupoId) => {
    axios.get(`https://apigabtecbi.automarco.cl:3003/api/select-marcas-gabtec?soloChinos=false&grupo=${grupoId}`)
      .then(r => {
        const idsGrupo = new Set((r.data || []).map(m => String(m.value)));
        if (!availableMarcaRef.current) return;
        const options = Array.from(availableMarcaRef.current.options);
        options.forEach(opt => {
          opt.selected = idsGrupo.has(opt.value);
        });
        const first = options.find(o => o.selected);
        if (first) first.scrollIntoView({ block: 'nearest' });
      })
      .catch(e => console.error('Error al cargar marcas del grupo:', e));
  };

  // ── Mover líneas ────────────────────────────────────────────
  const moveLineasRight = () => {
    if (!availableLineaRef.current) return;
    const selected = Array.from(availableLineaRef.current.selectedOptions).map(o => o.value);
    if (!selected.length) return;
    setSelectedLineaIds(prev => [...new Set([...prev, ...selected])]);
  };
  const moveLineasLeft = () => {
    if (!selectedLineaRef.current) return;
    const selected = Array.from(selectedLineaRef.current.selectedOptions).map(o => o.value);
    if (!selected.length) return;
    setSelectedLineaIds(prev => prev.filter(id => !selected.includes(id)));
  };

  // ── Mover marcas de producto ────────────────────────────────
  const moveMarcasProductoRight = () => {
    if (!availableMarcaProductoRef.current) return;
    const selected = Array.from(availableMarcaProductoRef.current.selectedOptions).map(o => o.value);
    if (!selected.length) return;
    setSelectedMarcaProductoIds(prev => [...new Set([...prev, ...selected])]);
  };
  const moveMarcasProductoLeft = () => {
    if (!selectedMarcaProductoRef.current) return;
    const selected = Array.from(selectedMarcaProductoRef.current.selectedOptions).map(o => o.value);
    if (!selected.length) return;
    setSelectedMarcaProductoIds(prev => prev.filter(id => !selected.includes(id)));
  };

  const handleGenerar = () => {
  if (selectedLineaIds.length === 0) {
    alert('Debes seleccionar al menos una línea');
    return;
  }
  // ← quitamos la validación de marcas y región
  setShowEmailModal(true);
  };

const handleEnviarPedido = async () => {
  if (!email || !email.includes('@')) {
    alert('Por favor ingresa un email válido');
    return;
  }

  const payload = {
    region,
    marcas: selectedMarcaIds,
    lineas: selectedLineaIds,
    marcasProducto: selectedMarcaProductoIds,
    cantidadItems: suggestedItems,
    descuento: parseFloat(discount) || 0,
    soloAplicacionPrincipal: onlyMainApp,
    email,
  };

  try {
    const response = await axios.post(
      'https://apigabtecbi.automarco.cl:3003/api/generar-sugerido',
      payload
    );

    if (response.data.success) {
      alert(`✅ Pedido sugerido generado con ${response.data.items} ítems y enviado a ${email}`);
      setShowEmailModal(false);
      setEmail('');
    }
  } catch (error) {
    console.error(error);
    alert('❌ Error: ' + (error.response?.data?.error || error.message));
  }
};
  // ── Render ──────────────────────────────────────────────────
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="card shadow">
            <div className="card-header bg-primary text-white">
              <h3 className="mb-0">Generador de Pedido Sugerido</h3>
            </div>

            <div className="card-body">

              {/* ── Región ── */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-label fw-bold">Región</label>
                  {loadingRegiones ? (
                    <div className="d-flex align-items-center">
                      <div className="spinner-border spinner-border-sm me-2" role="status" />
                      Cargando...
                    </div>
                  ) : errorRegiones ? (
                    <div className="alert alert-danger py-2 mb-0">{errorRegiones}</div>
                  ) : (
                    <select className="form-select" value={region} onChange={e => setRegion(e.target.value)} required>
                      <option value="">Seleccione región</option>
                      {regiones.map(reg => (
                        <option key={reg.value} value={reg.value}>{reg.label}</option>
                      ))}
                    </select>
                  )}
                </div>
              </div>

              {/* ── Marcas de Vehículos ── */}
              <div className="mb-4">
                <h5 className="mb-2">Marcas de Vehículos</h5>

                {loadingMarcas ? (
                  <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm me-2" role="status" />
                    Cargando marcas...
                  </div>
                ) : errorMarcas ? (
                  <div className="alert alert-danger py-2 mb-0">{errorMarcas}</div>
                ) : marcas.length === 0 ? (
                  <div className="alert alert-warning py-2 mb-0">No hay marcas disponibles</div>
                ) : (
                  <div className="row">
                    {/* Disponibles */}
                    <div className="col-md-5">
                      <label className="form-label text-muted">Disponibles</label>
                      <select ref={availableMarcaRef} multiple className="form-select" size="20">
                        {availableMarcas.map(m => (
                          <option key={m.value} value={String(m.value)}>{m.label}</option>
                        ))}
                      </select>
                    </div>

                    {/* Controles centrales */}
                    <div className="col-md-2 d-flex flex-column align-items-center justify-content-start gap-2 pt-4">
                      <button type="button" className="btn btn-primary btn-sm w-100" onClick={moveMarcasRight}>&gt;&gt;</button>
                      <button type="button" className="btn btn-primary btn-sm w-100" onClick={moveMarcasLeft}>&lt;&lt;</button>

                      {/* Separador */}
                      <hr className="w-100 my-1" />

                      {/* Botones de grupo */}
                      <small className="text-muted fw-bold text-center" style={{ fontSize: '0.7rem' }}>
                        Seleccionar grupo:
                      </small>
                      {loadingGrupos ? (
                        <div className="spinner-border spinner-border-sm" role="status" />
                      ) : (
                        grupos.map(g => (
                          <button
                            key={g.value}
                            type="button"
                            className="btn btn-outline-secondary btn-sm w-100"
                            style={{ fontSize: '0.7rem', padding: '2px 4px', lineHeight: '1.2' }}
                            onClick={() => handleGrupoClick(g.value)}
                            title={`Agregar todas las marcas del grupo ${g.label}`}
                          >
                            {g.label}
                          </button>
                        ))
                      )}
                    </div>

                    {/* Seleccionadas */}
                    <div className="col-md-5">
                      <label className="form-label text-muted">Seleccionadas</label>
                      <select ref={selectedMarcaRef} multiple className="form-select" size="20">
                        {selectedMarcas.map(m => (
                          <option key={m.value} value={String(m.value)}>{m.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {/* ── Líneas ── */}
              <div className="mb-4">
                <h5>Líneas</h5>
                {loadingLineas ? (
                  <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm me-2" role="status" />
                    Cargando líneas...
                  </div>
                ) : errorLineas ? (
                  <div className="alert alert-danger py-2 mb-0">{errorLineas}</div>
                ) : lineas.length === 0 ? (
                  <div className="alert alert-warning py-2 mb-0">No hay líneas disponibles</div>
                ) : (
                  <div className="row">
                    <div className="col-md-5">
                      <label className="form-label text-muted">Disponibles</label>
                      <select ref={availableLineaRef} multiple className="form-select" size="10">
                        {availableLineas.map(l => (
                          <option key={l.value} value={String(l.value)}>{l.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2 d-flex flex-column justify-content-center gap-2 pt-4">
                      <button type="button" className="btn btn-primary" onClick={moveLineasRight}>&gt;&gt;</button>
                      <button type="button" className="btn btn-primary" onClick={moveLineasLeft}>&lt;&lt;</button>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label text-muted">Seleccionadas</label>
                      <select ref={selectedLineaRef} multiple className="form-select" size="10">
                        {selectedLineas.map(l => (
                          <option key={l.value} value={String(l.value)}>{l.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {/* ── Marcas de Producto (por líneas seleccionadas) ── */}
              <div className="mb-4">
                <h5 className="mb-1">
                  Marcas de Producto
                  <small className="text-muted ms-2" style={{ fontSize: '0.8rem' }}>
                    (según líneas seleccionadas)
                  </small>
                </h5>

                {selectedLineaIds.length === 0 ? (
                  <div className="alert alert-info py-2 mb-0">
                    Selecciona al menos una línea para ver las marcas de producto disponibles.
                  </div>
                ) : loadingMarcasProducto ? (
                  <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm me-2" role="status" />
                    Cargando marcas de producto...
                  </div>
                ) : errorMarcasProducto ? (
                  <div className="alert alert-danger py-2 mb-0">{errorMarcasProducto}</div>
                ) : marcasProducto.length === 0 ? (
                  <div className="alert alert-warning py-2 mb-0">No hay marcas de producto para las líneas seleccionadas</div>
                ) : (
                  <div className="row">
                    <div className="col-md-5">
                      <label className="form-label text-muted">Disponibles</label>
                      <select ref={availableMarcaProductoRef} multiple className="form-select" size="10">
                        {availableMarcasProducto.map(m => (
                          <option key={m.marca_id} value={String(m.marca_id)}>{m.marca_nombre}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2 d-flex flex-column justify-content-center gap-2 pt-4">
                      <button type="button" className="btn btn-primary" onClick={moveMarcasProductoRight}>&gt;&gt;</button>
                      <button type="button" className="btn btn-primary" onClick={moveMarcasProductoLeft}>&lt;&lt;</button>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label text-muted">Seleccionadas</label>
                      <select ref={selectedMarcaProductoRef} multiple className="form-select" size="10">
                        {selectedMarcasProducto.map(m => (
                          <option key={m.marca_id} value={String(m.marca_id)}>{m.marca_nombre}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {/* ── Cantidad y Descuento ── */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-label fw-bold">Cantidad de ítems</label>
                  <select className="form-select" value={suggestedItems} onChange={e => setSuggestedItems(Number(e.target.value))}>
                    <option value={50}>50 ítems</option>
                    <option value={100}>100 ítems (máximo)</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-bold">Descuento (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Ej: 15.5"
                    value={discount}
                    onChange={e => setDiscount(e.target.value)}
                    step="0.01"
                  />
                </div>
              </div>

              <div className="form-check mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={onlyMainApp}
                  onChange={e => setOnlyMainApp(e.target.checked)}
                />
                <label className="form-check-label fw-bold">Solo aplicación principal</label>
              </div>
            </div>

            <div className="card-footer text-end">
              <button className="btn btn-success btn-lg px-5" onClick={handleGenerar}>
                Generar
              </button>
            </div>
          </div>
        </div>
      </div>
      {showEmailModal && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}
  >
    <div className="card" style={{ width: '400px' }}>
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">Enviar Pedido Sugerido por Email</h5>
      </div>
      <div className="card-body">
        <label className="form-label fw-bold">Email destinatario</label>
        <input
          type="email"
          className="form-control"
          placeholder="ejemplo@empresa.cl"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <small className="text-muted">
          El archivo Excel se generará y enviará automáticamente.
        </small>
      </div>
      <div className="card-footer text-end">
        <button
          className="btn btn-secondary me-2"
          onClick={() => setShowEmailModal(false)}
        >
          Cancelar
        </button>
        <button className="btn btn-success" onClick={handleEnviarPedido}>
          Enviar Pedido Sugerido
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default SugeridoPage;
